import { call, put, takeEvery } from 'redux-saga/effects';
import { bigCommerceActionCreators, BigCommerceApiKeys, DeleteBigCommerceStore } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../bigCommerceApi';

function* deleteBigCommerceStore(action: DeleteBigCommerceStore) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<number> = yield call(
    api.deleteBigCommerceStore,
    action.payload.bigCommerceStoreId
  );

  if (!response.requestFailed && response.value) {
    if (response.value) {
      yield put(bigCommerceActionCreators.removeStore(response.value));
    }
  } else {
    // TODO - show error message
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteBigCommerceStore() {
  yield takeEvery(BigCommerceApiKeys.DELETE_BIG_COMMERCE_STORE, deleteBigCommerceStore);
}
